export default {
  Action_Logs: "Action Logs",
  Action_Logs_Data: "Action Logs Data",
  Admin: "Admin",
  Amount: "Amount",
  Amount_must_be_lower_than_current_balance: "Amount must be lower than current balance",
  An_Error_Occurred: "An Error Occurred",
  API_Endpoint: "API Endpoint",
  Apply: "Apply",
  Arguments: "Arguments",
  Cancel: "Cancel",
  Currency: "Currency",
  Custom: "Custom",
  Custom_Date_Range: "Custom Date Range",
  Date_And_time: "Date & time",
  Date_From: "Date From",
  Date_To: "Date To",
  Endpoint: "Endpoint",
  Error_500: "Error 500. Please contact support using the 'Request Support' tab",
  Export: "Export",
  Export_Data: "Export Data",
  Export_Device_Logs: "Export Device Logs",
  Exported_file_in_csv_format: "Exported file will be in CSV format",
  Fetch_More_Data: "Fetch More Data",
  From_Date: "From Date",
  Inadequate_admin_privilege: "Inadequate admin privilege",
  Last_12hrs: "Last 12hrs",
  Last_24hrs: "Last 24hrs",
  Last_30_days: "Last 30 days",
  Last_365_days: "Last 365 days",
  Last_7_days: "Last 7 days",
  Lookup_Logs: "Lookup Logs",
  Memo: "Memo",
  Money_was_deducted_from_the_wallet: "Money was deducted from the wallet",
  No_refund_on_owner_wallet: "No refund on owner wallet",
  No_timezone_available: "No timezone available",
  Note_you_can_change_the_calendar_date_text: "Note: You can change the calendar date and search results to filter the data you want exported.",
  Please_provide_amount_greater_than: "Please provide amount greater than",
  PlugzioAdminDashboard: "Plugzio Admin Dashboard",
  PlugzioManagementDashboard: "Plugzio Management Dashboard",
  PlugzioUserDashboard: "Plugzio User Dashboard",
  Or: "Or",
  Refund: "Refund",
  Refund_Session: "Refund Session",
  Regex: "Regex",
  Rows: "Rows",
  Search: "Search",
  Search_Filter: "Search Filter",
  Search_RegEx: "Search RegEx",
  Session: "Session",
  Session_refund_amount_is_too_big: "Session refund amount is too big",
  Session_successfully_refunded: "Session successfully refunded",
  This_field_is_required: "This field is Required",
  Time_Zone: "Time Zone",
  Time_Zone_GMT: "Time Zone (GMT)",
  Timestamp: "Timestamp",
  Timezone: "Timezone",
  To_Date: "To Date",
  Today: "Today",
  Total_Rows: "Total Rows",
  Total_Session_Amount: "Total Session Amount",
  User: "User",
  Yesterday: "Yesterday",
  DidntSeeDeviceNumber: "Didn't see the device number",
  HowToActivatePlugzio: "How to activate Plugzio",
  StartUsingPlugzioByPluggingInBeforeEnteringPlugNumber:
    'Start using Plugzio by plugging in before entering the plug #. The plug # can be found on the front of the device under the QR code. In the example image the plug # is "XX123" circled in red.',
  StartUsingPlugzioByPluggingAndScanning: "Start using Plugzio by plugging in and scanning the QR code or entering the device number under the QR code.",
  Recent: "Recent",
  Favorite: "Favorite",
  Analysis: "Analysis",
  DetailedAnalysisComingSoon: "Detailed analysis coming soon",
  NoSessionsYet: "No Sessions Yet",
  Scan: "Scan",
  AtoK0to9AndDotOnly: "A to K, 0 to 9 and . only",
  DeviceHashSymbol: "Device #",
  Charge_another_car: "Charge another car",
  Ready_to_charge_your_car: "Ready to charge your car",
  Scan_QR_Code_or_enter_device_number: "Scan QR Code or enter device #",
  Consumption: "Consumption",
  Duration: "Duration",
  Activate: "Activate",
  Device: "Device",
  Last_updated: "Last updated",
  Hi: "Hi",
  Welcome_back: "Welcome back",
  Good_to_see_you: "Good to see you",
  Ongoing: "Ongoing",
  h: "h",
  m: "m",
  s: "s",
  ago: "ago",
  second: "second",
  minute: "minute",
  hour: "hour",
  hours: "hours",
  hour_with_value: "{n} hour",
  hours_with_value: "{n} hours",
  minute_with_value: "{n} minute",
  minutes_with_value: "{n} minutes",
  sec: "sec",
  min: "min",
  hr: "hr",
  Just_now: "Just now",
  min_ago: "{n} min ago",
  mins_ago: "{n} mins ago",
  End_session: "End session",
  End_Session: "End Session",
  Charging: "Charging",
  Favorites_are_limited_to_10_devices: "Favorites are limited to 10 devices",
  No_favorite_devices: "No favorite devices",
  Number_of_user_sessions: "Number of user sessions",
  Total_Kilowatt_hours_consumed: "Total Kilowatt hours consumed",
  Total_time_span_of_all_user_sessions: "Total time span of all user sessions",
  Edit_favorite_device: "Edit Favorite Device",
  Retry: "Retry",
  Submit: "Submit",
  Description: "Description",
  Failed_to_update_device_description: "Failed to update description",
  Failed_to_update_device_preferences: "Failed to update device preferences",
  Please_try_again: "Please try again",
  Confirm: "Confirm",
  Do_you_want_to_end_the_session_for: "Do you want to end the session for",
  This_will_terminate_the_ongoing_session: "This will terminate the ongoing session",
  Terminate_Ongoing_Session: "Terminate Ongoing Session",
  Stale_Session: "Stale Session",
  Charging_session_on_device: "Charging session on device",
  has_failed_to: "has failed to",
  Device_may_be_offline: "Device may be offline.",
  Please_try_again_or_contact_customer_support: "Please try again or contact customer support",
  Charging_Session_Timeout: "Charging Session Timeout",
  Max_Amount: "Max Amount",
  Cannot_favorite_a_previously_unregistered_device: "Cannot favorite a previously unregistered device",
  Edit_item: "Edit item",
  Edit_Device: "Edit Device",
  Edit_Manager: "Edit Manager",
  Edit_User: "Edit User",
  Date: "Date",
  Email: "Email",
  "E-mail": "E-mail",
  User_Does_Not_Exist: "User Does Not Exist",
  Manager_Does_Not_Exist: "Manager Does Not Exist",
  Lookup_Managers: "Lookup Managers",
  Lookup_Users: "Lookup Users",
  Lookup_Devices: "Lookup Devices",
  "Enter_Manager_E-mail": "Enter Manager E-mail",
  "Enter_User_E-mail": "Enter User E-mail",
  Searched_Managers: "Searched Managers",
  Searched_Users: "Searched Users",
  Enter_Device_ID: "Enter Device ID",
  Searched_Devices: "Searched Devices",
  Device_ID: "Device ID",
  Activating_the_device: "Activating the device",
  Insufficient_funds_in_wallet: "Insufficient funds in wallet",
  Access_to_this_device_is_restricted: "Access to this device is restricted. For access, please contact management.",
  This_device_is_configured_to_deliver_electricity: "This device is configured to deliver electricity when you plug in. No activation is needed!",
  This_device_has_been_disabled_by_management: "This device has been disabled by management. Please contact management for more information.",
  Device_not_set_up: 'Device "{plugIdentifier}" has not been set up by management. Please contact the property manager for more information.',
  There_is_no_charge_for_using_this_device: "There is no charge for using this device",
  No_Wallet_Available: "No wallet available",
  Wallet_Balance: "Wallet Balance",
  Creating: "Creating",
  wallet: "wallet",
  You_do_not_have_a_wallet: "You do not have a",
  We_would_like_to_automatically_create_one_for_you: "wallet. We would like to automatically create one for you. Please confirm to proceed.",
  Set_by: "Set by",
  company: "company",
  Set_by_your_property_manager: "Set by your property manager",
  Contact: "Contact",
  Low_Wallet_Balance: "Low Wallet Balance",
  Top_up: "Top up",
  Device_charges_in_currency: "This device charges in {currency} currency. Please create a {currency} wallet to use this device.",
  Failed_to_start_load_balanced_session: "Failed to start load balanced session. Please try again later.",
  Device_is_offline: "Device is offline or unreachable",
  Try_Again: "Try Again",
  Create_Wallet: "Create Wallet",
  TOP_UP: "TOP UP",
  Automatically_Start_Sessions: "Automatically Start Sessions",
  Would_you_like_to_automatically_start_sessions: "You are the only user authorized to use this device. Would you like to automatically start sessions when you plug in?",
  Learn_About_Automatically_Starting_Sessions: "Learn About Automatically Starting Sessions",
  I_acknowledge_the_risk: "I acknowledge the risk and would like to allow sessions to automatically start ",
  You_have_allowed_sessions_to_automatically_start: "You have allowed sessions to automatically start. Uncheck the box below to disable this feature",
  Allow_sessions_to_auto_start: "Allow sessions to auto start",
  Back: "Back",
  Device_Activation: "Device Activation",
  Automatically_Starting_Sessions: "Automatically Starting Sessions",
  Enabling_this_feature_keeps_the_Plugzio_device_on: "Enabling this feature keeps the Plugzio device on and ready to be used immediately.",
  This_allows_sessions_to_automatically_begin: "This allows sessions to automatically begin the moment you plug into the device for power.",
  You_will_be_able_to_use_the_Plugzio_device: "You will be able to use the Plugzio device without the hassle of activation.",
  Manually_stopping_a_session_through_the_dashboard: "Manually stopping a session through the dashboard will require you to manually start the session.",
  RISKS_RESPONSIBILITY: "RISKS & RESPONSIBILITY",
  With_easy_access_comes_less_security: "With easy access comes less security, auto activation means that anyone can plug in at your expense.",
  Enabling_sessions_to_automatically_start_means:
    " Enabling sessions to automatically start means that you be responsible for and billed for any and all consumption of this device without your authentication",
  You_will_be_billed_at_the_rate: "You will be billed at the rate specified by the manager's payment plan.",
  You_agree_to_automatically_accept_any_payment_plan:
    " You agree to automatically accept any payment plan set by the device manager. It is your responsibility to follow up with the manager regarding any payment issues.",
  This_is_a_preview_of_what_users_will_see:
    "This is a preview of what users will see when attempting to activate your device. Note that the payment plan information is for display purposes only.",
  Management_Information: "Management Information",
  Manager: "Manager",
  Phone: "Phone",
  Additional_Information: "Additional Information",
  Low_Wallet_Balance_Warning: "Low Wallet Balance Warning",
  Wallet_Amount: "Wallet Amount",
  Your_charging_session_will_get_interrupted: "Your charging session will get interrupted when you have insufficient funds.",
  Top_Up_Now: "Top Up Now",
  Deposit: "Deposit",
  PaypalFeeMessage: "Deposits are subjected to PayPal transactions & processing fees. Click",
  HERE: "HERE",
  for_more_information: "for more information",
  Next: "Next",
  Continue: "Continue",
  NonPaypalFeeMessage: "Deposits maybe subjected to transaction & processing fees.",
  Payment_plan_currency_is_invalid: "Payment plan currency is invalid. Please contact the manager of the device or customer support.",
  Error_no_payment_plan_assigned: "Error: No payment plan assigned",
  The_device_does_not_need_activation: "The device does not need activation. Just plug right in!",
  Pricing: "Pricing",
  Pricing_Detail: "Pricing Detail",
  Default_Billing: "Default Billing",
  Device_is: "Device is",
  disabled: "disabled",
  by_default: "by default",
  Device_is_disabled_during_this_time_period: "Device is disabled during this time period.",
  Sessions_will_automatically_terminate: "Sessions will automatically terminate. Please contact management for more information.",
  Activation: "Activation",
  Add_Sub_Rule: "Add Sub Rule",
  Edit: "Edit",
  Delete: "Delete",
  Move_Up: "Move Up",
  Move_Down: "Move Down",
  Add_new_conditional_rule: "Add new conditional rule",
  Delete_Time_Based_Rule: "Delete Time-Based Rule",
  Deleting_this_rule_will_also_delete_all_sub_rule: "Deleting this rule will also delete all sub rules. Please confirm if you would like to proceed.",
  the_value_should_not_be_the_same: "the value should not be the same",
  Sunday: "Sunday",
  Monday: "Monday",
  Tuesday: "Tuesday",
  Wednesday: "Wednesday",
  Thursday: "Thursday",
  Friday: "Friday",
  Saturday: "Saturday",
  January: "January",
  February: "February",
  March: "March",
  April: "April",
  May: "May",
  June: "June",
  July: "July",
  August: "August",
  September: "September",
  October: "October",
  November: "November",
  December: "December",
  at: "at",
  Manual_Topup: "Manual Topup",
  Wallet_balance_updated_successfully: "Wallet_balance_updated_successfully",
  Withdraw: "Withdraw",

  // Payment Plan Translations
  "For_the_first_{amount}_kwh_of_electricity_consumed": "For the first {amount} kWh of electricity consumed",
  "Between_{min}_kwh_and_{max}_kwh_of_electricity_consumed": "Between {min} kWh and {max} kWh of electricity consumed",
  "For_more_than_{amount}_kwh_of_electricity_consumed": "For more than {amount} kWh of electricity consumed",
  "For_the_first_{duration}_of_the_session": "For the first {duration} of the session",
  "Between_session_duration_of_{min}_and_{max}": "Between session duration of {min} and {max}",
  "For_session_duration_longer_than_{duration}": "For session duration longer than {duration}",
  "Every_year_for_calendar_days_between_{from}_and_{to}_with_html":
    'Every year for <b class="text-plugzio">calendar days</b> between <b class="text-plugzio">{from}</b> and <b class="text-plugzio">{to}</b>',
  "Every_week_from_{from}_to_{to}": "Every week from {from} to {to}",
  "{day}_of_the_week": "{day} of the week",
  "Every_day_for_time_of_day_between_{from}_and_{to}_with_html":
    'Every day for <b class="text-plugzio">time of day</b> between <b class="text-plugzio">{from}</b> and <b class="text-plugzio">{to}</b>',

  // Payment Plan Translations
  "I_would_like_to_<strong>disable</strong>_the_device.": ", I would like to <strong>disable</strong> the device.",
  "I_would_like_to_charge_users...": ", I would like to charge users...",
  "the_device_will_be_<strong>disable</strong>.": ", the device will be <strong>disable</strong>.",
  "you_will_be_billed...": ", you will be billed...",

  Pricing_in_next: "Pricing in next {n}",
  See_detail: "See detail",

  Login_to_activate_a_device_monitor_usage_and_access_your_wallet: "Login to activate a device, monitor usage and access your wallet",
  Please_agree_to_Plugzio_Terms_of_Service_and_Privacy_Policy_below_to_continue: "Please agree to Plugzio's Terms of Service and Privacy Policy below to continue",
  I_have_read_and_agreed_to: "I have read and agreed to",
  Terms_of_Service: "Terms of Service",
  Privacy_Policy: "Privacy Policy",
  Disagree: "Disagree",
  Agree: "Agree",
  Back_to_Login: "Back to Login",

  Unplug_from_charger_to_end_charging_session: "Unplug from charger to end charging session",
  You_have_an_ongoing_session_in_this_currency: "You have an ongoing session in {currency} currency, only one session is allowed per currency",
  You_currently_have_ongoing_session: "You currently have ongoing session",
  Please_end_current_session_before_starting_a_new_session: "Please end current session before starting a new session",
  Ongoing_Session_Exist: "Ongoing Session Exist",
  Unable_to_end_session_would_you_like_to_start_a_new_session_as_a_new_guest: "Unable to end session, would you like to start a new session as a new guest?",
  Start_new_guest_session: "Start new guest session",
  Done: "Done",
  Session_Summary: "Session Summary",
  Total_Cost: "Total Cost",
  Total_Consumption: "Total Consumption",
  Total_Duration: "Total Duration",
  Send_Receipt: "Send Receipt",
  Get_Receipt: "Get Receipt",
  Fill_out_the_Get_Receipt_form_below_to_receive_your_receipt_via_email: 'Fill out the "Get Receipt" form below to receive your receipt via e-mail.',
  Your_receipt_is_emailed_to_email: "Your receipt is e-mailed to <strong>{email}</strong>",
  Session_ID: "Session ID",
  Start_Time: "Start Time",
  End_Time: "End Time",
  Device_is_using_INR_currency_guest_not_supported: "Device is using INR currency, which is not supported for guest users. Register an account to continue or use another device.",
  Continue_as_guest: "Continue as guest",
  Sign_in: "Sign in",
  Payment_Plan: "Payment Plan",
  Show_Full_Payment_Plan: "Show Full Payment Plan",
  LEARN_MORE: "LEARN MORE",
  To_start_new_charging_session_please_end_your_current_ongoing_session_click_to_learn_more:
    "To start a new charging session, please end your current ongoing session. If you would like to start multiple concurrent sessions, please create a Plugzio account. Click here to",
  Sign_up_for_an_account: "Sign up for an account",
  Sign_up_for_an_account_to_access_the_following_features: "Sign up for an account to access the following features",
  Easy_activation_by_saving_devices_to_your_favorites_list: "Easy activation by saving devices to your favorites list",
  No_need_to_top_up_every_time_with_the_use_of_Plugzio_wallets: "No need to top up every time with the use of Plugzio wallets",
  Track_electrical_consumption_charging_duration_and_total_cost_over_over_time: "Track electrical consumption, charging duration and total cost over over time",
  Monitor_and_control_your_charging_sessions_across_multiple_devices: "Monitor and control your charging sessions across multiple devices",
  Remote_stop_charging_sessions_from_your_account: "Remote stop charging sessions from your account",
  Ability_to_start_multiple_and_concurrent_charging_sessions: "Ability to start multiple and concurrent charging sessions",
  Get_e_mail_notifications_about_your_charging_sessions: "Get e-mail notifications about your charging sessions",
  Select_payment_method: "Select payment method",
  Transaction_holding_fees_may_apply: "Transaction & holding fees may apply to your charging session",
  Transaction_holding_fee_number_will_apply: "Transaction & holding fee of {fee} will apply to your charging session",
  When_paying_with_debit_or_credit_email:
    "When paying with debit or credit, entering your personal e-mail is optional for an e-receipt. If you do not want to enter your personal e-mail, just enter {email}",
  Sign_up_for_an_account_to_save_on_holding_fees: "Sign up for an account to save on holding fees.",
  Version: "Version",
  Force_Lowercase: "Force Lowercase",
  A_100_hold_will_be_placed_on_your_card:
    "A $100 hold will be placed on your card. At the end of a charging session you will be billed the session amount and the holding balance will automatically be released within 72 hours to ensure the transaction is processed correctly.",
  Property_Name: "Property Name",
  Address_Line: "Address Line",
  City: "City",
  State: "State",
  Province: "Province",
  Zip_or_Postal_Code: "Zip / Postal Code",
  Country: "Country",
  Location: "Location",
  Device_Info: "Device Info",
  Company_or_Manager_Name: "Company / Manager Name",
  General_Information: "General Information",
  Location_Information: "Location Information",
  Address: "Address",
  Zip_Code: "Zip Code",
  Subscription_Information: "Subscription Information",
  Registration_Date: "Registration Date",
  Expiry_Date: "Expiry Date",
  Remaining_Days: "Remaining Days",
  Auto_Payment: "Auto Payment",
  Subscription_Model: "Subscription Model",
  Device_Information: "Device Information",
  Session_Details: "Session Details",
};
